import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Link from 'next/link';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import { topItems } from './tops-item.data';
import { ITopsItem } from './tops.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import styles from './Tops.module.scss';

const Tops: FC<IWidgetsSideBar> = ({ todayWidget, popularBooksWidget }) => {
  //seo block
  const SEO_TITLE = 'Рейтинги и Топы книг и авторов :: электронная библиотека : рейтинги по скачиванию, поиску, оценкам';
  const SEO_DESCRIPTION = 'Топ, рейтинги книг и авторов :: BookZ.ru';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref="/tops" isSmallPage breadcrumbs={<Breadcrumbs firstPageName="Рейтинги и топы книг и авторов" />} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget}>
      <ul className={styles.tops}>
        {topItems.map((item: ITopsItem) => (
          <li key={item.link} className={styles.tops__item}>
            <Link prefetch={false} href={item.link} className={styles.tops__link}>
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </Layout>
  );
};
export default Tops;
